import posed from 'react-pose';
import styled from 'styled-components';

import theme from './theme';

export const ErrorMessage = styled.div`
  color: ${Styles.color.error};
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 1rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.wrapperPadding};
  max-width: 500px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  button:not(:first-child) {
    margin-left: 1rem;
  }
`;

export const PromoCTA = styled.button`
  display: flex;
  flex-wrap: wrap;
  font-family: ${Styles.fontFamily.body};
  font-style: normal;
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 15px;
  line-height: 18px;
  cursor: pointer;
  align-items: center;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
`;

export const CallToActionHeader = styled.div`
  color: ${Styles.color.black};
  padding-right: 0.5rem;
`;

export const CTAButtonText = styled.div`
  color: ${Styles.color.primary};
  text-decoration: underline;
`;

export const PromoExpandToggleIcon = styled.div`
  margin-left: 4px;
  margin-top: 4px;
`;

export const ExpandedContainer = styled.div`
  margin: 0;
  padding: 0;
`;

export const Animated = posed(ExpandedContainer)({
  open: {
    height: 'auto',
    opacity: 1,
    transition: { duration: 100, ease: 'easeInOut' },
  },
  closed: {
    height: '0px',
    opacity: 0,
    transition: { duration: 100, ease: 'easeInOut' },
    overflow: 'hidden',
  },
});

export const MessageContainer = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.normal};
  padding: 0;
  margin: 0;
`;

export const SuccessCode = styled.div`
  color: ${Styles.color.validated};
  font-size: 15px;
  line-height: 18px;
  font-weight: ${Styles.fontWeight.normal};
  margin-bottom: 5px;
`;

export const SuccessMessage = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.normal};
  font-size: 14px;
`;

export const Divider = styled.hr`
  margin: 1rem 0 0;
  border: none;
  border-bottom: 1px solid ${Styles.color.grey.four};
`;
